import moment from "moment";
import { Mask } from "./Mask";

export class DateMask implements Mask {
  maxLength: number = 8;

  execute(value: string): string {
    let numericValue = value.replace(/\D/g, "").substring(0, this.maxLength); // Mantém apenas dígitos (max 8)

    let dia = "";
    let mes = "";
    let ano = "";

    if (numericValue.length > 0) {
      // Processa dia (DD)
      dia = numericValue.substring(0, 2);
      if (dia.length === 2) {
        const diaNum = parseInt(dia, 10);
        if (diaNum > 31) dia = "31";
        else if (diaNum === 0) dia = "01";
      }

      // Processa mês (MM)
      if (numericValue.length > 2) {
        mes = numericValue.substring(2, 4);
        if (mes.length === 2) {
          const mesNum = parseInt(mes, 10);
          if (mesNum > 12) mes = "12";
          else if (mesNum === 0) mes = "01";
        }

        // Processa ano (AAAA)
        if (numericValue.length > 4) {
          ano = numericValue.substring(4, 8);
        }
      }
    }

    if (numericValue.length === this.maxLength) {
      // Formata a string final
      return `${dia}${mes ? "/" + mes : ""}${ano ? "/" + ano : ""}`;
    }

    return numericValue;
  }

  format(value: string): string {
    return moment(value).format("DD/MM/YYYY");
  }

  expirationDate(value: string): string {
    const maxLength = 4;
    let numericValue = value.replace(/\D/g, "").substring(0, maxLength); // Mantém apenas dígitos (max 4)

    let mes = "";
    let ano = "";

    if (numericValue.length > 0) {
      // Processa mês (MM)
      if (numericValue.length > 2) {
        mes = numericValue.substring(0, 2);
        if (mes.length === 2) {
          const mesNum = parseInt(mes, 10);
          if (mesNum > 12) mes = "12";
          else if (mesNum === 0) mes = "01";
        }

        // Processa ano (AAAA)
        if (numericValue.length > 2) {
          ano = numericValue.substring(2, 4);
        }
      }
    }

    if (numericValue.length === maxLength) {
      // Formata a string final
      return `${mes}${ano ? "/" + ano : ""}`;
    }

    return numericValue;
  }

  reverse(value: string): string {
    const date = value.split("/");
    return `${date[2]}-${date[1]}-${date[0]}`;
  }
}
